import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'date-input-control',
  templateUrl: './date-input-control.component.html',
  styleUrls: ['./date-input-control.component.css']
})
export class DateInputControlComponent implements OnInit {

  //local variables  
  isValid: boolean;
  day: string;
  month: string;
  year: string;

  //input properties
  @Input() dobForm: FormGroup;
  @Input() minAge: number;
  @Output() OnDateSelected: EventEmitter<string> = new EventEmitter();

  //dropdown lists
  daysInMonth: string[] = [];
  yearList = new Array();

  constructor(private fb: FormBuilder, private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {

    var currentYear = moment().year();
    var maxApplicableYear = (currentYear - 19);
    this.yearList.push(maxApplicableYear);

    for (var i = 80; i > 0; --i) {
      --maxApplicableYear;
      this.yearList.push(maxApplicableYear);
    }

    this.dobForm.addControl('year', new FormControl('', Validators.required));
    this.dobForm.addControl('month', new FormControl('', Validators.required));
    this.dobForm.addControl('day', new FormControl('', Validators.required));
  }

  isInputTouchedAndValid(): boolean | null {
    var touched = (this.dobForm.controls['year'].touched || this.dobForm.controls['month'].touched || this.dobForm.controls['day'].touched);
    if (!touched) {
      return null;
    }

    //get days of month
    this.daysInMonth = [];
    if (this.year != null && this.month != null) {
      var numOfDays = moment(this.year + "-" + this.month, "YYYY-MM").daysInMonth();
      for (var i = 1; i <= numOfDays; i++) {
        this.daysInMonth.push(
          (i.toString().length == 1) ? '0' + i : i.toString()
        );
      }

      //clear selected day if exceeds last day of month
      if (this.day != null && parseInt(this.day) > this.daysInMonth.length) {
        this.day = null;
      }
    }
    else {
      this.day = null;
    }

    this.OnDateSelected.emit(null);
    try {
      var parsedDOB = moment(this.dobForm.controls['year'].value + '-' + this.dobForm.controls['month'].value + '-' + this.dobForm.controls['day'].value, 'YYYY-MM-DD', true);
      if (parsedDOB.isValid()) {
        if (moment().diff(parsedDOB, 'years') >= this.minAge) {
          var dateOfBirth = parsedDOB.format('YYYY-MM-DD');
          this.OnDateSelected.emit(dateOfBirth);
          return true;
        }
      }
    } catch{ ; }

    return false;
  }

}
